import { Action } from '@ngrx/store';
import { MemberProfileUpdateEmailPayload } from '@shared/shared/interfaces/member-profile-update-email-payload.interface';
import { IMemberProfile } from '@shared/shared/interfaces/member-profile.interfaces';

// update email
export const UPDATE_EMAIL = '[Member Profile] Update Email';
export const UPDATE_EMAIL_SUCCESS = '[Member Profile] Update Email Success';
export const UPDATE_EMAIL_FAIL = '[Member Profile] Update Email Fail';

export class UpdateEmail implements Action {
  readonly type = UPDATE_EMAIL;
  constructor(public payload: MemberProfileUpdateEmailPayload) {}
}

export class UpdateEmailSuccess implements Action {
  readonly type = UPDATE_EMAIL_SUCCESS;
  constructor(public payload: any) {}
}

export class UpdateEmailFail implements Action {
  readonly type = UPDATE_EMAIL_FAIL;
}

// view profile
export const VIEW_PROFILE = '[Member Profile] View Profile';
export const VIEW_PROFILE_SUCCESS = '[Member Profile] View Profile Success';
export const VIEW_PROFILE_FAIL = '[Member Profile] View Profile Fail';

export class ViewProfile implements Action {
  readonly type = VIEW_PROFILE;
  constructor(public payload: number) {}
}

export class ViewProfileSuccess implements Action {
  readonly type = VIEW_PROFILE_SUCCESS;
  constructor(public payload: IMemberProfile) {}
}

export class ViewProfileFail implements Action {
  readonly type = VIEW_PROFILE_FAIL;
  constructor(public payload: any) {}
}

// update show tour
export const UPDATE_SHOW_TOUR = '[Member Profile] Update Show Tour';
export const UPDATE_SHOW_TOUR_SUCCESS = '[Member Profile] Update Show Tour Success';
export const UPDATE_SHOW_TOUR_FAIL = '[Member Profile] Update Show Tour Fail';

export class UpdateShowTour implements Action {
  readonly type = UPDATE_SHOW_TOUR;
}

export class UpdateShowTourSuccess implements Action {
  readonly type = UPDATE_SHOW_TOUR_SUCCESS;
  constructor(public payload: any) {}
}

export class UpdateShowTourFail implements Action {
  readonly type = UPDATE_SHOW_TOUR_FAIL;
  constructor(public payload: any) {}
}

// update member profile
export const UPDATE_MEMBER_PROFILE = '[Member Profile] Update Member profile';
export const UPDATE_MEMBER_PROFILE_SUCCESS = '[Member Profile] Update Member profile Success';
export const UPDATE_MEMBER_PROFILE_FAIL = '[Member Profile] Update Member profile Fail';

export class UpdateMemberProfile implements Action {
  readonly type = UPDATE_MEMBER_PROFILE;
  constructor(public payload: any) {}
}

export class UpdateMemberProfileSuccess implements Action {
  readonly type = UPDATE_MEMBER_PROFILE_SUCCESS;
  constructor(public payload: any) {}
}

export class UpdateMemberProfileFail implements Action {
  readonly type = UPDATE_MEMBER_PROFILE_FAIL;
  constructor(public payload: any) {}
}

// clear member profile
export const CLEAR_MEMBER_PROFILE = '[Member Profile] Clear Member profile';

export class ClearMemberProfile implements Action {
  readonly type = CLEAR_MEMBER_PROFILE;
}

export type MemberProfileAction =
  | UpdateEmail
  | UpdateEmailSuccess
  | UpdateEmailFail
  | ViewProfile
  | ViewProfileSuccess
  | ViewProfileFail
  | UpdateShowTour
  | UpdateShowTourSuccess
  | UpdateShowTourFail
  | UpdateMemberProfile
  | UpdateMemberProfileSuccess
  | UpdateMemberProfileFail
  | ClearMemberProfile;
